import { render, staticRenderFns } from "./studentRestList.vue?vue&type=template&id=65b4afa1&scoped=true&"
import script from "./studentRestList.vue?vue&type=script&lang=js&"
export * from "./studentRestList.vue?vue&type=script&lang=js&"
import style0 from "./studentRestList.vue?vue&type=style&index=0&id=65b4afa1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b4afa1",
  null
  
)

export default component.exports